import React, { useEffect } from "react";
import { SwiperSlide } from "components/swiper";
import ProductItem from "components/product/item";
import useModal from "hooks/useModal";
import RichText from "components/rich-text";
import CommonSlider from "components/common-slider";
import Button from "components/button";
import { useInView } from "react-intersection-observer";
import { trackViewItemList } from "services/analytics";
import AddAllToCartButton from "components/add-all-to-cart";
import { formatTitle } from "helpers/format-title";

const ProductSlider = ({ navClass, data }) => {
	const {
		_key, title = "", amount: { mobile, desktop } = {},
		content, cta, showAddAllToCart = false, bundle,
		openCartOnAdd = false, addToSub = false, hideATCPrice = false, newLayout = false
	} = data;
	const [modal, openModal, closeModal] = useModal("product");

	const products = bundle ? bundle.details?.products : data.products;

	const [ref, inView] = useInView({
		threshold: 0,
		rootMargin: "50px",
		triggerOnce: true,
	});

	useEffect(() => {
		if (inView) {
			trackViewItemList({
				title, id: _key, products
			});
		}
	}, [inView]);

	if (!products || products?.length === 0) return null;

	return (
		<div ref={ref} className="relative md:ml-5">
			<div className="text-center mb-5">
				{title && <h2>{formatTitle(title)}</h2> }
				{showAddAllToCart && <div className="hidden md:flex justify-end w-full mt-3 md:pr-20 xl:pr-32">
					<AddAllToCartButton products={products} className="hidden md:block" />
				</div>}
				{content?.data && <div className="mb-3"><RichText value={content} /></div>}
			</div>
			<div className="w-4/5 m-auto md:w-4/5">
				<CommonSlider desktop={desktop} mobile={mobile} navClass={navClass}>
					{products?.length > 0 && products.map((product, index) => (
						<SwiperSlide key={product.id || index} className="cursor-pointer">
							<ProductItem
								product={{ ...product, index }}
								isOpen={modal[product._id]}
								openModal={() => openModal(product._id)}
								closeModal={() => closeModal(product._id)}
								openCart={openCartOnAdd}
								addToSub={addToSub}
								hideATCPrice={hideATCPrice}
								newLayout={newLayout}
							/>
						</SwiperSlide>
					))}
				</CommonSlider>
			</div>
			{showAddAllToCart && <div className="md:hidden my-8">
				<AddAllToCartButton products={products} className="block md:hidden mx-auto" />
			</div>}
			<Button data={cta} className="mt-10 btn-center" />
		</div>
	);
};

export default ProductSlider;